import { createApi } from '@reduxjs/toolkit/query/react';
import { HttpMethod } from '@vision/ui/enums';
import {
  ApiResponse,
  AuthorizedApp,
  AuthorizedAppCreateRequest,
  AuthorizedAppCreateResponse,
  HttpBaseRequest,
} from '@vision/ui/interfaces';
import { buildEndpointWithQuery, createHttpExtraOptions } from '@vision/ui/utils';
import { axiosBaseQuery } from './base.service';

export const AuthorizedAppsService = createApi({
  reducerPath: 'AuthorizedAppsService',
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    authorizedApps: builder.query<ApiResponse<AuthorizedApp[]>, HttpBaseRequest<{ accountId: string; query?: string }>>(
      {
        query: ({ accountId, query }) => ({
          url: buildEndpointWithQuery(`/v2/accounts/${accountId}/authorized_apps`, query),
          method: HttpMethod.GET,
        }),
      },
    ),
    createAuthorizedApp: builder.mutation<
      AuthorizedAppCreateResponse,
      { accountId: string; data: AuthorizedAppCreateRequest }
    >({
      query: ({ accountId, data }) => ({
        url: `/v2/accounts/${accountId}/authorized_apps`,
        method: HttpMethod.POST,
        data,
        extraOptions: createHttpExtraOptions({
          notification: {
            translationMessageKey: 'http.message.authorizedAppCreate.{{status}}',
          },
        }),
      }),
      transformResponse: (response: ApiResponse<AuthorizedAppCreateResponse>) => response.data,
    }),
    deleteAuthorizedApp: builder.mutation<void, { accountId: string; id: string }>({
      query: ({ accountId, id }) => ({
        url: `/v2/accounts/${accountId}/authorized_apps/${id}/delete`,
        method: HttpMethod.POST,
        extraOptions: createHttpExtraOptions({
          notification: {
            translationMessageKey: 'http.message.authorizedAppDelete.{{status}}',
          },
        }),
      }),
    }),
  }),
});

export const { useLazyAuthorizedAppsQuery, useCreateAuthorizedAppMutation, useDeleteAuthorizedAppMutation } =
  AuthorizedAppsService;
